export const load = () => ({
	title: 'Insulating Apartment Windows: Tips + Ideas for Renters',
	showTitle: true,
});
